export default "/images/at-sign.svg?453d6aa23f31b71d7e47fe667153245c";